import {
  defaultGetParams as getParams,
  payloadAsParam
} from '../../signalr/helpers'
import type { InvokeDefinition, StreamDefinition } from '../../signalr/types'
import {
  type FetchAdminWatchlistsByIdentifierAction,
  type FetchAdminWatchlistsByUserAction,
  type FetchWatchListsAction,
  fetchAdminWatchlistsByIdentifierSuccessAction,
  fetchAdminWatchlistsByUserSuccessAction,
  fetchWatchListsSuccessAction
} from './actions'
import { watchlistDetailsFromResponse } from './helpers'
import type { WatchListResponse } from './types'

export const WATCHLISTS_BUFFER_DELAY = 100

export const fetchWatchListDefinition: StreamDefinition<
  [],
  WatchListResponse[],
  FetchWatchListsAction
> = {
  method: 'GetWatchlists',
  strategy: 'switch',
  bufferMs: WATCHLISTS_BUFFER_DELAY,
  getParams,
  mapResponse: (watchlists, action) =>
    fetchWatchListsSuccessAction(
      action.payload.gridIndex,
      watchlists.map(watchlistDetailsFromResponse)
    ),
  errorAction: 'watchList.fetchWatchListsFailure',
  cancelOn: []
}

export const fetchAdminWatchlistsByUserDefinition: InvokeDefinition<
  [number],
  WatchListResponse[],
  FetchAdminWatchlistsByUserAction
> = {
  method: 'GetWatchlistsForUser',
  strategy: 'switch',
  getParams: payloadAsParam,
  mapResponse: (watchlists) =>
    fetchAdminWatchlistsByUserSuccessAction(
      watchlists.map(watchlistDetailsFromResponse)
    )
}

export const fetchAdminWatchlistsByIdentifierDefinition: InvokeDefinition<
  [string],
  WatchListResponse[],
  FetchAdminWatchlistsByIdentifierAction
> = {
  method: 'GetWatchlistsContainingSecurity',
  strategy: 'switch',
  getParams: payloadAsParam,
  mapResponse: (watchlists) =>
    fetchAdminWatchlistsByIdentifierSuccessAction(
      watchlists.map(watchlistDetailsFromResponse)
    )
}
